import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Nav from "./Navbar";
import Footer from "./Footer";

export default function ExecutiveManagementDetails() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/managers/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setData(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  if (!data) return null; // or some placeholder

  const { Firstname, Lastname, middleName, position, Remark, dataOfBirth, passportNumber, published_at, created_at, updated_at, Passport, profile, educations, departements, institues } = data;

  const fullName = `${Firstname} ${middleName ? middleName : ''} ${Lastname}`;
  const profileImageUrl = profile && profile.length > 0 ? `${process.env.REACT_APP_API_URL}${profile[0].url}` : "default-image-url.jpg";
  const passportUrl = Passport && Passport.length > 0 ? `${process.env.REACT_APP_API_URL}${Passport[0].url}` : "default-image-url.jpg";
  const education = educations && educations.length > 0 ? educations[0].TypesOfDegree : "Not specified";
  const department = departements && departements.length > 0 ? departements[0].FieldName : "Not specified";
  const instituteName = institues && institues.length > 0 ? institues[0].InstititeName : "Not specified";

  return (
    <>
      <Nav />
      <section className="pb-10 bg-blueGray-200">
        <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
          <div className="grid grid-cols-3 gap-4">
            <div className="mt-4 bg-white shadow-md rounded-lg text-left p-4">
              <h2 className="text-xl font-semibold mb-2">{fullName}</h2>
              {/* <p><strong>Position:</strong> {position?.Title || "Not specified"}</p> */}
              <p><strong>Position:</strong> {position && position.Title ? position.Title : "Not specified"}</p>
              {/* <p><strong>Remark:</strong> {Remark}</p> */}
              <p><strong>Date of Birth:</strong> {formatDate(dataOfBirth)}</p>
              {/* <p><strong>Passport Number:</strong> {passportNumber}</p> */}
              <p><strong>Education:</strong> {education}</p>
              <p><strong>Department:</strong> {department}</p>
              {/* <p><strong>Institution:</strong> {instituteName}</p> */}
              {/* <p><strong>Published At:</strong> {published_at}</p> */}
              {/* <p><strong>Created At:</strong> {created_at}</p> */}
              {/* <p><strong>Updated At:</strong> {updated_at}</p> */}
            </div>
            <div className="bg-indigo-300 p-4 rounded-lg shadow-lg">
              <img 
                className="object-cover object-center h-48 w-96 rounded-lg" 
                src={profileImageUrl} 
                alt="Profile" 
                style={{ width: '100%', height: '100%' }} 
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

